import React from "react";
import EPrepaidPayments from "./view/_prepaid_payments";
import { Grid, makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  height: {
    height: "100%",
    width: "100%",
  },
}));

const EOneTimePayments = () => {
  const classes = useStyle();
  return <Grid className={classes.height}>{<EPrepaidPayments/>}</Grid>;
};

export default EOneTimePayments;
